module.exports = __webpack_public_path__ + "assets/img/Employment-Innovations-Pillar-Page-Resource.765c4b6f.jpg";